import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description ContentFurniture icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { ContentFurniture } from '@sravni/design-system-icons'
 *
 * <ContentFurniture />
 * ```
 */
var ContentFurniture = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "ContentFurniture", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M16.736 7V4.6c0-.424-.18-.831-.502-1.131A1.778 1.778 0 0 0 15.022 3H6.451c-.455 0-.891.169-1.213.469-.321.3-.502.707-.502 1.131V7", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M2.736 8.778v4.444A1.778 1.778 0 0 0 4.514 15H16.96a1.778 1.778 0 0 0 1.777-1.778V8.778a1.778 1.778 0 1 0-3.555 0v1.778H6.29V8.778a1.778 1.778 0 1 0-3.555 0ZM4.736 15v1M16.736 15v1", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { ContentFurniture };
//# sourceMappingURL=ContentFurniture.js.map
